// extracted by mini-css-extract-plugin
module.exports = {"section":"K4_section__q88z6"};